






















import { defineComponent, PropType } from '@vue/composition-api';
import { TextDraftWithUser } from '@oare/types';

export default defineComponent({
  props: {
    draft: {
      type: Object as PropType<Pick<TextDraftWithUser, 'notes' | 'content'>>,
      required: true,
    },
  },
});
